<template>
  <div v-if="isInViewDefined" :id="adID"
       style="text-align: center; position: fixed; top: 60px;"
       :style="styleObject">
  </div>
</template>

<script>
googletag.cmd.push();
</script>

<script setup>
import {onMounted, computed} from "vue";

const isInViewDefined = typeof inView !== "undefined"
const props = defineProps({
  side: {
    validator(value) {
      // The value must match one of these strings
      return ["right", "left"].includes(value)
    }
  }
})

const styleObject = computed(() => {
  if (props.side) {
    return {[props.side]: 0};
  }

  return {};
});

const adID = `socialwolvez_com_160x600_siderail_${props.side}_desktop`

onMounted(() => {
  if (!isInViewDefined) return

  inView("#" + adID).once("enter", (function () {
    if (typeof googletag === "undefined") return

    googletag.cmd.push(function () {
      googletag.display(adID);

      if (typeof stpd === "undefined") return
      stpd.initializeAdUnit(adID);
    });
  }));
})

</script>

<style scoped>

</style>